import React, { FunctionComponent } from "react";

interface RocketIconProps {
  color?: string;
  size?: string;
}

const RocketIcon: FunctionComponent<RocketIconProps> = ({
  color = "#2F373D",
  size = "40",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M16.0314 17.4936L16.5547 20.0872C16.6029 20.326 16.5622 20.5741 16.4405 20.785L15.9284 21.672C15.7963 21.9007 15.4828 21.941 15.2973 21.753L10.5992 16.9928C10.3621 16.7525 10.068 16.5762 9.74444 16.4802L2.29579 14.2708C2.04785 14.1972 1.93382 13.9113 2.06313 13.6873L2.58406 12.785C2.70584 12.5741 2.9004 12.4149 3.13124 12.3372L5.63908 11.4936L8.54158 6.46629C10.2332 3.53639 13.7259 2.21181 17.2025 2.86878C17.4034 2.90674 17.5856 3.01193 17.7189 3.16694C20.0262 5.8493 20.6255 9.53639 18.9339 12.4663L16.0314 17.4936ZM14.0345 18.669C14.0982 18.7549 14.2341 18.6944 14.2129 18.5896L13.9966 17.5179C13.9484 17.2792 13.989 17.031 14.1108 16.8201L17.2018 11.4663C18.3004 9.56357 18.0849 7.11588 16.6889 5.10102C16.5402 4.88633 16.3029 4.74932 16.0426 4.72784C13.5997 4.52626 11.3726 5.56274 10.2736 7.46629L7.18262 12.8201C7.06083 13.031 6.86624 13.1903 6.63538 13.2679L5.53777 13.6371C5.44009 13.6699 5.44995 13.8112 5.55126 13.8301L10.4661 14.7501C10.9621 14.8429 11.4047 15.1198 11.7051 15.5252L14.0345 18.669Z"
          fill={color}
        />
        <path
          d="M7.53377 21.2838C9.23488 21.5021 10.9535 21.0415 12.3176 20.002L10.3612 18.8725C9.83355 19.1325 9.25696 19.2892 8.66327 19.3275C8.40009 18.7933 8.247 18.2165 8.20917 17.63L6.25195 16.5C6.03372 18.2011 6.49422 19.9197 7.53377 21.2838Z"
          fill={color}
        />
        <path
          d="M18.75 8.25L16.5 3.75L11.25 5.25L6.75 12L3.75 13.5L10.5 15.75L15 20.25V17.25L17.25 13.5L18.75 8.25Z"
          fill={color}
        />
        <path
          d="M11.8061 9.98406C11.9433 10.4964 12.2785 10.9333 12.7379 11.1985C13.1973 11.4637 13.7432 11.5356 14.2555 11.3983C14.7679 11.261 15.2047 10.9258 15.47 10.4664C15.7352 10.0071 15.807 9.46115 15.6698 8.94879C15.5325 8.43643 15.1973 7.99959 14.7379 7.73438C14.2785 7.46916 13.7326 7.39729 13.2203 7.53457C12.7079 7.67186 12.2711 8.00706 12.0059 8.46643C11.7406 8.92579 11.6688 9.47171 11.8061 9.98406Z"
          fill="#E9F7F3"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RocketIcon;
